<template>
  <window-default ref="window" :resolve="find" :mock="mock" :props="props" v-slot="{ data }" :proccess-data="proccessData"
    @loaded="(obj) => model = obj" @save="save">
    <window-body class="wrapper-lg">
      <e-row mr>
        <e-col size="1">
          <erp-s-field label="ID:">
            <erp-input v-model="model.id" size="2" readonly />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col>
          <erp-s-field label="Nome:">
            <erp-input v-model="model.nome" autofocus size="2" />
          </erp-s-field>
        </e-col>
      </e-row>

      <e-row mr>
        <e-col style="min-width: 45%;">
          <erp-s-field label="Data de Emissão:">
            <datetime-input date-type="date" date-format="##/##/####" v-model.lazy="model.dataEmissao" simpleBorder />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row mr>
        <e-col style="min-width: 45%;">
          <erp-s-field label="Data vencimento:">
            <datetime-input date-type="date" date-format="##/##/####" v-model.lazy="model.dataVencimento"
              simpleBorder />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row mr>
        <e-col style="min-width: 45%;">
          <erp-s-field label="Data para pedir:">
            <datetime-input date-type="date" date-format="##/##/####" v-model.lazy="model.dataParaPedir" simpleBorder />
          </erp-s-field>
        </e-col>
      </e-row>
      <e-row mr>
        <e-col style="min-width: 45%;">
          <erp-s-field label="Data Pedido:">
            <datetime-input date-type="date" date-format="##/##/####" v-model.lazy="model.dataPedido" simpleBorder />
          </erp-s-field>
        </e-col>
      </e-row>
      <!-- <e-row mr>
        <e-col>
          <erp-s-field label="Ativo:">
            <erp-checkbox v-model="model.active" />
          </erp-s-field>
        </e-col>
      </e-row> -->
    </window-body>
  </window-default>
</template>

<script>
import { WindowBody, ErpSField, ErpInput, ErpCheckbox } from 'uloc-vue-plugin-erp'
import WindowDefault from '../../../reuse/window/Default'
import {
  findValidadeDocumento,
  newValidadeDocumento as _new,
  updateValidadeDocumento as update,
} from '../../../domain/validadeDocumentos/services'
import DatetimeInput from '../../../reuse/input/Datetime'
import ERow from '../../layout/components/Row'
import ECol from '../../layout/components/Col'
import save from '../save';
import { datePtToEn } from "@/utils/date"

let mock = {
  id: null,
  nome: null,
  prazo: null,
  dataVencimento: null,
  dataParaPedir: null,
  dataPedido: null,
}

export default {
  name: 'Window',
  components: { ECol, ERow, WindowDefault, WindowBody, ErpSField, ErpInput, DatetimeInput },
  props: ['props'],
  data() {
    return {
      model: JSON.parse(JSON.stringify(mock))
    }
  },
  mounted() {
  },
  computed: {
    find() {
      return findValidadeDocumento
    },
    mock() {
      return mock
    }
  },
  methods: {
    update: update,
    new: _new,
    save: save,
    beforeSave(data) {
      try {
        if (data.dataEmissao) {
          data.dataEmissao = datePtToEn(data.dataEmissao)
        }
        if (data.dataVencimento) {
          data.dataVencimento = datePtToEn(data.dataVencimento)
        }
        if (data.dataParaPedir) {
          data.dataParaPedir = datePtToEn(data.dataParaPedir)
        }
        if (data.dataPedido) {
          data.dataPedido = datePtToEn(data.dataPedido)
        }
      } catch (error) {
        console.log(error)
      }
      return data
    },
    proccessData (_data) {
      let _mock = JSON.parse(JSON.stringify(this.mock))
      const data = Object.assign(_mock, _data)
      const datas = [
      'dataEmissao',
      'dataVencimento',
      'dataParaPedir',
      'dataPedido',
      ]
      datas.map(key => {
        if (data[key] && data[key].date) {
          data[key] = this.$options.filters.formatDate(data[key].date)
        }
      })
      return data
    }
  }
}
</script>
